<div class="theme-picker d-flex align-items-center" [class.flex-wrap]="!inline" [class.w-100]="fill">
  @if (!inline) {
    <label class="w-100" [ngClass]="labelClass" [for]="inputId">{{ label }}</label>
  }
  <select class="custom-select custom-select-sm nav-font12 theme-select"
          [class.is-fill]="fill"
          [id]="inputId"
          [attr.aria-label]="inline ? label : null"
          [disabled]="disabled"
          [ngModel]="selectValue()"
          (ngModelChange)="choose($event)">
    @if (missing()) {
      <option [value]="selectValue()" disabled>{{ deletedLabel }}</option>
    }
    @for (option of options(); track option.value) {
      <option [value]="option.value">{{ option.text }}</option>
    }
  </select>

  @if (showSwatches && selected(); as theme) {
    <span class="d-flex align-items-center ml-2" role="img"
          [attr.aria-label]="theme.name + ' colours'">
      @for (role of roles; track role) {
        <span class="theme-swatch" [style.background-color]="theme.theme.colorPalette[role]"></span>
      }
    </span>
  }

  @if (outOfDate && !disabled) {
    <button type="button"
            class="btn btn-link btn-sm nav-font12 p-0 ml-2 text-nowrap"
            [tooltip]="'This theme has been edited since its colours were applied here'"
            container="body"
            (click)="updateRequested.emit()">
      <i class="fas fa-arrows-rotate mr-1" aria-hidden="true"></i>Update available
    </button>
  }
</div>
